import axios from "axios";
import * as types from "./mutation_types";

export const retrieve = ({ commit }) => {
  commit(types.ETB_SHOW_TOGGLE_LOADING);
  axios
    .get("/api/myetb/")
    .then((response) => {
      commit(types.ETB_SHOW_TOGGLE_LOADING);
      commit(types.ETB_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.ETB_SHOW_TOGGLE_LOADING);
      commit(types.ETB_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.ETB_SHOW_RESET);
};
